<div class="p-3" *ngIf="artifact.description" [innerHTML]="artifact.description"></div>
<div class="m-auto" *ngIf="!artifact.locked">
    <div class="m-5">
        <button mat-stroked-button color="accent" class="w-100" (click)="utilService.gotToFieldPrint()" [disabled]="userService.isEduAgent()">Go to Fieldprint</button>
    </div>
</div>